import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { bindTwitchAuth } from "../../hooks/useTwitchAuth";
import App from "./App";
import "./globals.css";
bindTwitchAuth();
var root = createRoot(document.getElementById("root"));
root.render(_jsx(StrictMode, { children: _jsx(App, {}) }));
